import { render, staticRenderFns } from "./TaskLabelDD.vue?vue&type=template&id=77b90062"
import script from "./TaskLabelDD.vue?vue&type=script&lang=js"
export * from "./TaskLabelDD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports